"use client";

import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fetchMe } from "@/lib/client";
import { DialogTrigger } from "@radix-ui/react-dialog";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import styles from "./index.module.scss";

export function JobHuntingPopup({
  popupStatusFromCookie
}: {
  popupStatusFromCookie: string | undefined;
}) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const pathname = usePathname();

  const setPopupStatus = async (status: "never" | "later") => {
    try {
      await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/job_hunting_survey_v1/popup_status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        mode: "cors",
        body: JSON.stringify({
          status
        })
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handlePressNever = async () => {
    setPopupStatus("never");
  };

  const handleOpenChange = async (isOpen: boolean) => {
    setIsPopupOpen(isOpen);
  };

  const handleCloseWithoutButton = async () => {
    setPopupStatus("later");
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const showPopup = async () => {
      try {
        const user = await fetchMe();
        const isLogined = user.role !== "guest";

        if (isLogined && popupStatusFromCookie !== "never" && popupStatusFromCookie !== "later") {
          setIsPopupOpen(true);
        }
      } catch (error) {
        console.error(error);
      }
    };

    showPopup();
  }, [popupStatusFromCookie]);

  if (pathname === "/signup/profile-settings" || pathname === "/") {
    return null;
  }

  return (
    <Dialog open={isPopupOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <button type="button" className={styles.JobHuntingPopupButton}>
          今なら永年プランが無料！
        </button>
      </DialogTrigger>
      <DialogContent
        className={styles.JobHuntingPopupContent}
        onEscapeKeyDown={handleCloseWithoutButton}
        onPointerDownOutside={handleCloseWithoutButton}
        onCloseClick={handleCloseWithoutButton}
      >
        <DialogTitle />
        <Image
          className={styles.image}
          src="/job-hunting-survey.png"
          alt="Job hunting survey"
          width={1280}
          height={720}
        />
        <div className={styles.footer}>
          <DialogClose asChild>
            <Button
              variant="outline"
              onClick={handlePressNever}
              disabled={popupStatusFromCookie === "never"}
            >
              今後表示しない
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button asChild onClick={handlePressNever}>
              <Link href="/job-hunting-survey/confirm">特典を受け取る</Link>
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
